import React from 'react';

import MessageGroupPage from '../components/MessageGroupPage';

const MessageGroupContainer = () => {
  return <MessageGroupPage />;
};

export default MessageGroupContainer;
